import * as actionType from 'constants/action-constants';

const initialState = {
  augmentaionPreview: null,
  isLoading: false,
  error: '',
  status: '',
};

/**
 *
 * @param {*} state - The Intial state
 * @param {*} action - The action object containing action type and payload
 * @returns - Updated state object
 */
const augmentationReducer = (state = initialState, action) => {
  /*
        This reducer function makes changes in the redux state 
        based on the actions
    */

  switch (action.type) {
    // Reset error case.
    case actionType.RESET_ERROR:
      return {
        ...state,
        error: '',
      };

    // Get augmentation data.
    case actionType.GET_AUGMENTATION_REQUEST:
      return {
        ...state,
        isLoading: true,
        status: '',
        error: '',
        augmentaionPreview: null,
      };
    case actionType.GET_AUGMENTATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        augmentaionPreview: action.payload.data,
        status: 'success',
      };
    case actionType.GET_AUGMENTATION_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
      };
    default:
      return state;
  }
};

export default augmentationReducer;
